/** Master kill switch for exec Custom Metrics (CONF-212). Set to false to hide
 *  the button and panel for everyone and stop overrides applying — a saved
 *  quote's customMetrics block then stays inert on load. A constant rather
 *  than an env var so rollback is a one-line revert (same as CCI_FEATURE_ENABLED).
 *  M3: this only reverts the LOADED configurator's live display. A quote that
 *  was already saved with overrides keeps its custom figures baked into its
 *  saved `metrics` blob (buildQuoteInput wrote displayMetrics, not metrics),
 *  so the quotes list still shows the custom numbers for that row even with
 *  the switch off — only re-opening it in the configurator reverts to computed. */
export const CUSTOM_METRICS_ENABLED = true;

/** Spec §2 gate: execAccess, not in consultation mode, feature on. */
export function showCustomMetricsPanel({ hasExecAccess, consultationMode }) {
  return CUSTOM_METRICS_ENABLED && hasExecAccess === true && consultationMode !== true;
}
